import { render, staticRenderFns } from "./Plugins.vue?vue&type=template&id=f2e91356&scoped=true&"
import script from "./Plugins.vue?vue&type=script&lang=js&"
export * from "./Plugins.vue?vue&type=script&lang=js&"
import style0 from "./Plugins.vue?vue&type=style&index=0&id=f2e91356&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e91356",
  null
  
)

export default component.exports